import {
  getLeoUuid,
  LeoUUID,
  getList,
  LeoRPCRequest,
  LeoRPCResponse,
  LeoRPCError,
  LeoRPCResult,
  LeoRPC
} from "@surya-digital/leo-ts-types";
/* eslint-disable import/export */
export abstract class GetProjectsByAPIKeyRPC implements
  LeoRPC<GetProjectsByAPIKeyRPC.Request, GetProjectsByAPIKeyRPC.Response, GetProjectsByAPIKeyRPC.Errors.Errors>
{
  abstract execute(
    request: GetProjectsByAPIKeyRPC.Request
  ): Promise<LeoRPCResult<GetProjectsByAPIKeyRPC.Response, GetProjectsByAPIKeyRPC.Errors.Errors>>;
}

export namespace GetProjectsByAPIKeyRPC {

  export class InvalidRequestError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidRequestError";
    }
  }

  export interface RequestDTO {
    apiKeyId: string;
  }
  
  export class Request implements LeoRPCRequest {
    readonly isGetProjectsByAPIKeyRPCRequest: boolean = true;
  
    readonly apiKeyId: LeoUUID;
  
  
    constructor(
    apiKeyId: LeoUUID
    ) {
      this.apiKeyId = apiKeyId;
    }
  
    static fromDTO(dto: RequestDTO): Request {
      const apiKeyId = getLeoUuid(dto, "apiKeyId", InvalidRequestApiKeyIdError);
      return new Request(
        apiKeyId
      );
    }
  
    toDTO(): RequestDTO {
      const dto: RequestDTO = {
          apiKeyId: this.apiKeyId.toDTO()
      };
      return dto;
    }
    }
  
  Request.prototype.toString = function toString(): string {
    return `GetProjectsByAPIKeyRPC(apiKeyId='${this.apiKeyId}')`;
  };
  

  export class InvalidResponseError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidResponseError";
    }
  }

  export interface ResponseDTO {
    projects: string[];
  }
  
  export class Response implements LeoRPCResponse {
    readonly isGetProjectsByAPIKeyResponse: boolean = true;
  
    readonly projects: LeoUUID[];
  
  
    constructor(
    projects: LeoUUID[]
    ) {
      this.projects = projects;
    }
  
    static fromDTO(dto: ResponseDTO): Response {
      const projects = getList<string, LeoUUID>(
        dto,
        "projects",
        (e: string) => new LeoUUID(e),
        InvalidResponseProjectsError
      );
      return new Response(
        projects
      );
    }
  
    toDTO(): ResponseDTO {
      const dto: ResponseDTO = {
          projects: this.projects.map((e: LeoUUID) => { return e.toDTO(); })
      };
      return dto;
    }
    }
  
  Response.prototype.toString = function toString(): string {
    return `GetProjectsByAPIKey(projects='${this.projects}')`;
  };
  

  export enum RPCError {
    InvalidApiKey = "INVALID_API_KEY"
  }

  export namespace Errors {
    
    export interface InvalidApiKeyDTO {
      code: string;
    }
    
    export class InvalidApiKey extends LeoRPCError<RPCError> {
      readonly isInvalidApiKey: boolean = true;
    
    
      constructor(
      ) {
        const code = RPCError.InvalidApiKey;
        super(code);
      }
    
    
      toDTO(): InvalidApiKeyDTO {
        const dto: InvalidApiKeyDTO = {
          code: this.code,
        };
        return dto;
      }
    
      }
    
    InvalidApiKey.prototype.toString = function toString(): string {
      return `GetProjectsByAPIKeyRPC.INVALID_API_KEY()`;
    };
    

    export type Errors = InvalidApiKey;
    export type ErrorsDTO = InvalidApiKeyDTO;

    export const fromDTO = (dto: ErrorsDTO): Errors => {
      switch (dto.code) {
        case RPCError.InvalidApiKey:
          return new InvalidApiKey();
        default:
          throw new InvalidResponseError(`Unexpected error code: ${dto.code}`);
      }
    };
  }
}

export class InvalidRequestApiKeyIdError extends GetProjectsByAPIKeyRPC.InvalidRequestError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestApiKeyIdError";
  }
}

export class InvalidResponseProjectsError extends GetProjectsByAPIKeyRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseProjectsError";
  }
}

export class InvalidResponseInvalidApiKeyError extends GetProjectsByAPIKeyRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseInvalidApiKeyError";
  }
}

